var _g, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgPragmaPayProductIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2303_1912)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4939 15.7021C34.8331 15.9316 34.7609 16.443 34.387 16.6102C29.2516 18.9058 25.6731 24.0588 25.6731 30.0476C25.6731 36.0365 29.2516 41.1895 34.387 43.4851C34.7609 43.6522 34.8331 44.1637 34.4939 44.3932C31.7298 46.2632 28.3963 47.3553 24.8077 47.3553C15.2489 47.3553 7.5 39.6064 7.5 30.0476C7.5 20.4889 15.2489 12.7399 24.8077 12.7399C28.3963 12.7399 31.7298 13.8321 34.4939 15.7021Z",
    fill: "url(#paint0_linear_2303_1912)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.3848 42.1638C47.076 42.1638 52.5002 36.7396 52.5002 30.0484C52.5002 23.3573 47.076 17.933 40.3848 17.933C33.6937 17.933 28.2694 23.3573 28.2694 30.0484C28.2694 36.7396 33.6937 42.1638 40.3848 42.1638ZM38.4624 20.724C38.9747 20.6189 39.4892 20.8642 39.7535 21.3155C41.2548 23.8791 42.1153 26.8636 42.1153 30.049C42.1153 33.2345 41.2548 36.2189 39.7535 38.7826C39.4892 39.2339 38.9747 39.4792 38.4624 39.3741C38.2635 39.3333 38.0668 39.2863 37.8727 39.2334C37.2261 39.0569 37.0183 38.2845 37.3679 37.7126C38.7327 35.4807 39.5192 32.8567 39.5192 30.049C39.5192 27.2414 38.7327 24.6174 37.3679 22.3854C37.0183 21.8136 37.2261 21.0411 37.8727 20.8647C38.0668 20.8117 38.2635 20.7647 38.4624 20.724Z",
    fill: "#F43454"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2303_1912",
    x: 5.5,
    y: 11.7399,
    width: 49.0002,
    height: 38.6154,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2303_1912"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2303_1912",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2303_1912",
    x1: 34.7093,
    y1: 15.3562,
    x2: 9.3314,
    y2: 37.8562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#914187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.145,
    stopColor: "#65408A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.665,
    stopColor: "#3E4CB4"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPragmaPayProductIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pragma-pay-product-icon.1951e51e.svg";
export { ForwardRef as ReactComponent };